import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Formik, Form } from 'formik';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { intlShape } from '../../../../../components/prop-types';
import { validationMessages } from '../../../../../i18n/common';
import ConfirmForm from './CSDeleteForm';
import Debug from '../../../../../components/Debug';


const buildValidationSchema = formatMessage => (Yup.object().shape({
  confirmation_code: Yup
    .string()
    .required(formatMessage(validationMessages.required)),
  re_confirmation_code: Yup
    .string()
    .oneOf([Yup.ref('confirmation_code'), null], validationMessages.sameAs)
    .required(formatMessage(validationMessages.required)),
}));

const i18n = defineMessages({
  header: {
    id: 'del_header.cs.spec',
    defaultMessage: 'Delete Concurrent Study',
  },
});

class CSDeleteConfirmModal extends Component {
  render() {
    const {
      reject,
      confirm,
      modalOpen,
      intl: { formatMessage },
      selectedCS,
    } = this.props;
    const initialValues = {
      confirmation_code: selectedCS || '',
      re_confirmation_code: '',
    };
    const validationSchema = buildValidationSchema(formatMessage);
    const modalHeader = formatMessage(i18n.header);
    const dialogFooter = (
      <Fragment>
        <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
          {text => (
            <Button
              className="p-button-secondary"
              label={text}
              type="submit"
              onClick={reject}
            />
          )}
        </FormattedMessage>
        &nbsp;
        <FormattedMessage id="actions.delete" defaultMessage="Delete">
          {text => (
            <Button label={text} type="submit" />
          )}
        </FormattedMessage>
        <Debug />
      </Fragment>
    );
    return (
      <Formik
        onSubmit={confirm}
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        render={() => (
          <Form>
            <Dialog
              header={modalHeader}
              footer={dialogFooter}
              visible={modalOpen}
              onHide={reject}
              modal
            >
              <div className="panel panel-no-border">
                <div className="panel-body">
                  <ConfirmForm
                    selectedCS={selectedCS}
                  />
                </div>
              </div>
            </Dialog>
          </Form>
        )}
      />
    );
  }
}

CSDeleteConfirmModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  selectedCS: PropTypes.string,
  intl: intlShape.isRequired,
};

CSDeleteConfirmModal.defaultProps = {
  selectedCS: null,
};

export default injectIntl(CSDeleteConfirmModal);
